import { RoundButton } from '@cian/ui-kit';
import { IconClose16 } from '@cian/ui-kit/icons';
import * as React from 'react';

import { Info } from './components/Info';
import { UndergroundStations } from './components/UndergroundStations';
import * as styles from './styles.css';
import { ETestId } from '../../../common/constants';
import { IDailyRentOfferForMobileSite } from '../../../common/repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { ButtonsContainer } from '../../containers/Buttons';
import { CarouselContainer } from '../../containers/Carousel';
import { FavoriteButton } from '../FavoriteButton';
import { Address } from '../OfferCard/components/Address';
import { Labels } from '../OfferCard/components/Labels';
import { Rating } from '../OfferCard/components/Rating';

interface IOfferCardPreviewProps {
  offer: IDailyRentOfferForMobileSite;
  offerLink: string;
  showFavoriteButton?: boolean;
  hasDates: boolean;
  onSlideChange(): void;
  onCardClick(): void;
  onAddToFavorites(): void;
  onRemoveFromFavorites(): void;
  onMoreClick(): void;
  onBookClick(): void;
  onCallClick(): void;
  onChatClick(): void;
  onClose(): void;
}

export const OfferCardPreview = ({
  offer,
  offerLink,
  hasDates,
  showFavoriteButton = true,
  onSlideChange,
  onCardClick,
  onAddToFavorites,
  onRemoveFromFavorites,
  onMoreClick,
  onBookClick,
  onCallClick,
  onChatClick,
  onClose,
}: IOfferCardPreviewProps) => {
  const hasRatingOrReviews = Boolean(offer.rating || offer.reviewsCount);

  return (
    <div data-testid={ETestId.OfferPreview} data-partner={offer.isCianPartner} className={styles['container']}>
      <CarouselContainer
        containerClassName={styles['carousel-container']}
        className={styles['carousel']}
        offer={offer}
        offerLink={offerLink}
        onSlideChange={onSlideChange}
        onClick={onCardClick}
        extraControls={
          <div className={styles['modal-controls']}>
            {showFavoriteButton && (
              <div className={styles['button-container']}>
                <FavoriteButton
                  isFavorite={offer.isFavorite}
                  onAdd={onAddToFavorites}
                  onRemove={onRemoveFromFavorites}
                />
                <RoundButton
                  theme="fill_dark"
                  size="M"
                  onClick={onClose}
                  title="Закрыть"
                  icon={<IconClose16 color="brand-white" />}
                  data-testid="PreviewModalHiddenCloseButton"
                />
              </div>
            )}
          </div>
        }
      />
      <a
        className={styles['content']}
        onClick={onCardClick}
        href={offerLink}
        target="_blank"
        rel="noopener noreferrer"
        data-linkname="link_to_card"
      >
        <Labels className={styles['labels']} labels={offer.photoLabels} />
        <Info {...offer} hasDates={hasDates} hasRating={hasRatingOrReviews} />
        <Rating className={styles['rating']} offer={offer} />
        <UndergroundStations {...offer} />
        <div className={styles['address']}>
          <Address address={offer.geo.address} />
        </div>
      </a>
      <ButtonsContainer
        className={styles['buttons-container']}
        offer={offer}
        offerLink={offerLink}
        onMoreClick={onMoreClick}
        onBookClick={onBookClick}
        onCallClick={onCallClick}
        onChatClick={onChatClick}
      />
    </div>
  );
};
